var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
var HiddenInput = styled.input(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  border: 0;\n  height: 0;\n  margin: 0;\n  opacity: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 0;\n"])));
export default HiddenInput;